import { render, staticRenderFns } from "./Referentiels.vue?vue&type=template&id=20aa1e32"
import script from "./Referentiels.vue?vue&type=script&lang=js"
export * from "./Referentiels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/tonumeric/poureux-gestion/projects/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20aa1e32')) {
      api.createRecord('20aa1e32', component.options)
    } else {
      api.reload('20aa1e32', component.options)
    }
    module.hot.accept("./Referentiels.vue?vue&type=template&id=20aa1e32", function () {
      api.rerender('20aa1e32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Referentiels.vue"
export default component.exports